import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ModuleGroupPermissionService } from '../module-group-permission.service';
import {
  ModuleGroupPermissionAddPayload,
  ModuleGroupPermissionRootNoParentPayload,
} from '../module-group-permission.interface';
import { environment } from 'src/environments/environment';

import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-add-module-group-permission',
  templateUrl: './add-module-group-permission.component.html',
  styleUrls: ['./add-module-group-permission.component.scss'],
})
export class AddModuleGroupPermissionComponent implements OnInit {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    parent_id: new FormControl(null, []),
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    observations: new FormControl('', []),
  });

  isPartLoading: boolean = false;

  moduleGroupsNoParent$!: Observable<
    ModuleGroupPermissionRootNoParentPayload[]
  >;

  constructor(
    private dialogRef: MatDialogRef<AddModuleGroupPermissionComponent>,
    private moduleGroupPermissionService: ModuleGroupPermissionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getPermissionNoParentList();
  }

  getPermissionNoParentList() {
    this.moduleGroupsNoParent$ =
      this.moduleGroupPermissionService.getModulesNoParent();
    this.moduleGroupsNoParent$
      .pipe(finalize(() => (this.isPartLoading = false)))
      .subscribe({
        next: (platformSections) => {
          this.moduleGroupsNoParent$ = of(platformSections);
          this.isPartLoading = false;
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
          this.isPartLoading = false;
        },
      });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.moduleGroupPermissionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { parent_id, name, slug, observations } = this.form
      .value as ModuleGroupPermissionAddPayload;
    const payload: ModuleGroupPermissionAddPayload = {
      parent_id,
      name,
      slug,
      observations,
    };

    this.moduleGroupPermissionService
      .addModule(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
